import React from "react";
import { motion } from "framer-motion";
import styles from "./index.module.css";
import { FiArrowUpRight } from "react-icons/fi";
import { CiSatellite1 } from "react-icons/ci";
import { CiApple, CiBadgeDollar } from "react-icons/ci";
import { CiShop } from "react-icons/ci";

const titleVariants = {
  hidden: { opacity: 0, y: 40 },
  visible: {
    opacity: 1,
    y: 0,
    transition: { duration: 0.75, ease: "easeOut" },
  },
};

const cardVariants = {
  hidden: { opacity: 0, y: -40 },
  visible: {
    opacity: 1,
    y: 0,
    transition: { duration: 0.7, ease: "easeOut" },
  },
};

const InfoSection = () => {
  const inforCards = [
    {
      id: 1,
      icon: <CiShop />,
      title: "For All Types Businesses",
      description:
        "Our cloud-based point of sale system is designed to cater to the unique needs of businesses across all industries. Whether you run a retail store, restaurant, or service-based business, our solution offers the flexibility and scalability to support your operations, streamline transactions, and enhance customer satisfaction.",
      link: "https://web.whatsapp.com/send?phone=94741041212&text=Hi%2C%20I%E2%80%99d%20like%20to%20learn%20more%20about%20all%20the%20features%20of%20your%20POS%20solution.%20Could%20you%20please%20assist%20me%3F",
    },
    {
      id: 2,
      icon: <CiBadgeDollar />,
      title: "Cost Effective With Affordable Price",
      description:
        "Get the best value for your business with our point of sale system. We offer competitive pricing without compromising on quality, ensuring that you can access top-notch features and support at an affordable rate. Invest in a solution that saves you money while boosting your business efficiency.",
      link: "https://web.whatsapp.com/send?phone=94741041212&text=Hi%2C%20I%E2%80%99d%20like%20to%20learn%20more%20about%20all%20the%20features%20of%20your%20POS%20solution.%20Could%20you%20please%20assist%20me%3F",
    },
    {
      id: 3,
      icon: <CiSatellite1 />,
      title: "Easy to Setup & No IT Knowledge Need",
      description:
        "Our cloud point of sale system is user-friendly and quick to set up, requiring no technical expertise. Start managing your business effortlessly with an intuitive interface that makes installation and operation a breeze, so you can focus on what you do best.",
      link: "https://web.whatsapp.com/send?phone=94741041212&text=Hi%2C%20I%E2%80%99d%20like%20to%20learn%20more%20about%20all%20the%20features%20of%20your%20POS%20solution.%20Could%20you%20please%20assist%20me%3F",
    },
    {
      id: 4,
      icon: <CiApple />,
      title: "Modern & Attractive User Dashboard",
      description:
        "Experience the power of a sleek, modern dashboard designed for ease of use and visual appeal. Our cloud point of sale system features an intuitive interface that provides real-time insights and streamlined navigation, making it simple to manage your business with style.",
      link: "https://web.whatsapp.com/send?phone=94741041212&text=Hi%2C%20I%E2%80%99d%20like%20to%20learn%20more%20about%20all%20the%20features%20of%20your%20POS%20solution.%20Could%20you%20please%20assist%20me%3F",
    },
  ];

  return (
    <div className={styles.infoSectionContainer}>
      <motion.div
        className={styles.titleDiv}
        variants={titleVariants}
        initial="hidden"
        whileInView="visible"
        viewport={{ once: true, amount: 0.4 }}
      >
        <div className={styles.titleTop}>
          Sell Intelligently Our Brand-New Retail Point of Sale
        </div>
        <div className={styles.titleLow}>
          <span className={styles.premiumText}>#Premium</span>{" "}
          <span>Software</span>
        </div>
      </motion.div>

      <div className={styles.infoCardsDiv}>
        {inforCards.map((card) => (
          <motion.div
            key={card.id}
            className={styles.infoCard}
            variants={cardVariants}
            initial="hidden"
            whileInView="visible"
            viewport={{ once: true, amount: 0.2 }}
          >
            <div className={styles.topInnerInfoCardDiv}>
              <div className={styles.cardIcon}>{card.icon}</div>
              <div className={styles.cardTitle}>{card.title}</div>
              <div className={styles.cardDescription}>{card.description}</div>
            </div>
            <a
              className={styles.link}
              href={card.link}
              target="_blank"
              rel="noreferrer"
            >
              <div className={styles.cardLink}>
                Learn More <FiArrowUpRight className={styles.cardLinkIcon} />
              </div>
            </a>
          </motion.div>
        ))}
      </div>
    </div>
  );
};

export default InfoSection;
